.columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--mantine-spacing-xl);
}

.column {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
}

.columnTitle {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.addressLine {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-primary);
}

.empty {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-secondary);
  font-style: italic;
}

.services {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  padding-top: var(--mantine-spacing-md);
  border-top: 1px solid var(--mantine-color-default-border);
  margin-top: var(--mantine-spacing-md);
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mantine-spacing-xs);
}

.sectionTitle {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  padding-top: var(--mantine-spacing-md);
  border-top: 1px solid var(--mantine-color-default-border);
  margin-top: var(--mantine-spacing-md);
}

.sectionValue {
  font-size: var(--mantine-font-size-md);
  color: var(--adl-text-primary);
}

.tradeshowLine {
  font-size: var(--mantine-font-size-md);
  color: var(--adl-text-secondary);
}

.instructions {
  font-size: var(--mantine-font-size-md);
  color: var(--adl-text-primary);
  font-style: italic;
}
